
import { combineReducers } from "redux";
import AddReducer from "./addProduct/AddReducer";
import fliteBookingReducer from "./fliteBooking/fliteBookingReducer";

const rootReducer = combineReducers({
    flitebooking: fliteBookingReducer,
    products:AddReducer
});

export default rootReducer;